import { render, staticRenderFns } from "./SystemFunction.vue?vue&type=template&id=dcdf4846&"
import script from "./SystemFunction.vue?vue&type=script&lang=js&"
export * from "./SystemFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports